<nav id="sidebar" class="sidebar-wrapper">
  <div class="sidebar-content">
    <div class="sidebar-brand">
      <a [routerLink]="'/piglet'">
        <img [src]="'assets/images/logo-dark2.png'" height="24" class="block dark:hidden h-12 mx-auto" alt="">
        <img [src]="'assets/images/logo-light2.png'" height="24" class="hidden dark:block h-12 mx-auto" alt="">
      </a>
    </div>
    <ngx-simplebar style="height: calc(100% - 70px);">
      <ul class="sidebar-menu border-t dark:border-white/10 border-gray-100" data-simplebar >
        <li [ngClass]="menu === '/' ? 'active' : ''">
          <a [routerLink]="'/'"><i data-feather="airplay" class="h-4 w-4 me-3"></i>{{ 'PIGLET.SIDEBAR.DASHBOARD' | translate }}</a>
        </li>

        <li class="sidebar-dropdown" [ngClass]="['/explore','/item-detail','/upload-work'].includes(menu) ? 'active' : ''">
          <a href="#" (click)="openMenu($event, '/explore-item')"><i data-feather="users" class="h-4 w-4 me-3"></i>{{ 'PIGLET.SIDEBAR.USERS' | translate }}</a>
          <div class="sidebar-submenu" [ngClass]="['/explore-item','/explore','/item-detail','/upload-work'].includes(subManu || menu) ? 'block' : ''">
            <ul>
              <li [ngClass]="menu === '/explore' ? 'active' : ''"><a [routerLink]="'/explore'">{{ 'PIGLET.SIDEBAR.USERS_SEARCH_CHARACTER' | translate }}</a></li>
              <li [ngClass]="menu === '/item-detail' ? 'active' : ''"><a [routerLink]="'/item-detail'">{{ 'PIGLET.SIDEBAR.USERS_TRADE_LOGS' | translate }}</a></li>
              <li [ngClass]="menu === '/upload-work' ? 'active' : ''"><a [routerLink]="'/upload-work'">{{ 'PIGLET.SIDEBAR.USERS_TRACE_ITEM' | translate }}</a></li>
            </ul>
          </div>
        </li>

        <li class="sidebar-dropdown" [ngClass]="ARTICLES_MENU_LIST.includes(menu) ? 'active' : ''">
          <a href="#" (click)="openMenu($event, ARTICLES_MENU_LIST[0])"><i data-feather="copy" class="h-4 w-4 me-3"></i>{{ 'PIGLET.SIDEBAR.ARTICLES' | translate }}</a>
          <div class="sidebar-submenu" [ngClass]="ARTICLES_MENU_LIST.includes(subManu || menu) ? 'block' : ''">
            <ul>
              <li [ngClass]="menu === '/piglet/articles/list' ? 'active' : ''"><a [routerLink]="'/piglet/articles/list'">{{ 'PIGLET.SIDEBAR.ARTICLES' | translate }}</a></li>
              <li [ngClass]="menu === '/piglet/articles/categories' ? 'active' : ''"><a [routerLink]="'/piglet/articles/categories'">{{ 'PIGLET.SIDEBAR.ARTICLES_CATEGORIES' | translate }}</a></li>
              <li [ngClass]="menu === '/piglet/articles/category-types' ? 'active' : ''"><a [routerLink]="'/piglet/articles/category-types'">{{ 'PIGLET.SIDEBAR.ARTICLES_CATEGORY_TYPES' | translate }}</a></li>
            </ul>
          </div>
        </li>

        <li class="sidebar-dropdown" [ngClass]="['/starter','/faqs','/privacy','/terms'].includes(menu) ? 'active' : ''">
          <a href="#" (click)="openMenu($event, '/page-item')"><i data-feather="book" class="h-4 w-4 me-3"></i>{{ 'PIGLET.SIDEBAR.CATALOG' | translate }}</a>
          <div class="sidebar-submenu" [ngClass]="['/page-item','/starter','/faqs','/privacy','/terms'].includes(subManu || menu) ? 'block' : ''">
            <ul>
              <li [ngClass]="menu === '/starter' ? 'active' : ''"><a [routerLink]="'/starter'">{{ 'PIGLET.SIDEBAR.CATALOG_PRODUCTS' | translate }}</a></li>
              <li [ngClass]="menu === '/faqs' ? 'active' : ''"><a [routerLink]="'/faqs'">{{ 'PIGLET.SIDEBAR.CATALOG_CATEGORIES' | translate }}</a></li>
              <li [ngClass]="menu === '/privacy' ? 'active' : ''"><a [routerLink]="'/privacy'">{{ 'PIGLET.SIDEBAR.CATALOG_COLLECTIONS' | translate }}</a></li>
            </ul>
          </div>
        </li>

        <li class="sidebar-dropdown" [ngClass]="['/login','/signup','/signup-success','/reset-password','/lock-screen'].includes(menu) ? 'active' : ''">
          <a href="#" (click)="openMenu($event, '/auth-item')"><i data-feather="shopping-cart" class="h-4 w-4 me-3"></i>{{ 'PIGLET.SIDEBAR.ORDERS' | translate }}</a>
          <div class="sidebar-submenu" [ngClass]="['/auth-item'].includes(subManu) ? 'block' : ''">
            <ul>
              <li [ngClass]="menu === '/login' ? 'active' : ''"><a [routerLink]="'/login'">{{ 'PIGLET.SIDEBAR.ORDERS_ALL' | translate }}</a></li>
              <li [ngClass]="menu === '/signup' ? 'active' : ''"><a [routerLink]="'/signup'">{{ 'PIGLET.SIDEBAR.ORDERS_TRANSACTIONS' | translate }}</a></li>
            </ul>
          </div>
        </li>

        <li class="sidebar-dropdown" [ngClass]="SETTINGS_MENU_LIST.includes(menu) ? 'active' : ''">
          <a href="#" (click)="openMenu($event, SETTINGS_MENU_LIST[0])"><i data-feather="settings" class="h-4 w-4 me-3"></i>{{ 'PIGLET.SIDEBAR.SETTINGS' | translate }}</a>
          <div class="sidebar-submenu" [ngClass]="SETTINGS_MENU_LIST.includes(subManu) ? 'block' : ''">
            <ul>
              <li [ngClass]="menu === '/piglet/settings/application-settings' ? 'active' : ''"><a [routerLink]="'/piglet/settings/application-settings'">{{ 'PIGLET.SIDEBAR.APPLICATION_SETTINGS' | translate }}</a></li>
            </ul>
          </div>
        </li>
      </ul>
      <!-- sidebar-menu  -->
    </ngx-simplebar>
  </div>
</nav>
